
import { MapLocation } from '@/types/location';

// Fitonia Gym Locations
export const fitoniaGyms: MapLocation[] = [
  {
    id: 19001,
    name: "Fitonia Gym - Riyadh (Al Taawun)",
    type: "Gym",
    devices: 3,
    coordinates: [24.77998008018464, 46.704161783728125],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-40",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
